import React, { Component } from 'react';
import { Row, Col, Table, Button, Modal } from 'react-bootstrap';
import moment from 'moment';
import licenseService from '../../services/licenseService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPen, faKey, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { dateFormat, dateDisplayFormat } from "../../utilities/dateTime";
import { LICENSE_TYPE, USER_ASSIGNABLE_PAM_LICENSE_TYPE_IDS } from '../../utilities/constants';
import licenseTypeEnum from "../../utilities/enums/licenseTypeEnum";

const layerJotLicenseType = licenseTypeEnum.layerJotLicense.value;

const MODAL_STATE = Object.freeze({
    NEW: "new",
    EDIT: "edit"
})
class LicenseKeys extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            modalState: undefined,
            showEditModal: false,
            showDeleteLicenseModal: false,
            returnError: '',
            licenseKeyModalHeaderText: "",
            editLicense: {},
            disabled: false
        };
        this.showEditModal = this.showEditModal.bind(this);
        this.showNewModal = this.showNewModal.bind(this);
        this.hideEditModal = this.hideEditModal.bind(this);
        this.showDeleteLicenseModal = this.showDeleteLicenseModal.bind(this);
        this.hideDeleteLicenseModal = this.hideDeleteLicenseModal.bind(this);
        this.handleSaveLicense = this.handleSaveLicense.bind(this);
        this.handleDeleteLicense = this.handleDeleteLicense.bind(this);
        this.handleUserInput = this.handleUserInput.bind(this);
        this.handleUserIntInput = this.handleUserIntInput.bind(this);
        this.handleSaveLicenseResponse = this.handleSaveLicenseResponse.bind(this);
    }

    getLicenseByOrgSiteId(licenses, orgSiteId, licenseTypeId) {
        return licenses.filter(x => x.orgSiteId === orgSiteId && x.licenseTypeId === licenseTypeId);
    }

    showEditModal(license, event) {
        if (license.licenseTypeId === LICENSE_TYPE.PAMSiteLicense) {
            const viewerLicensesForSite = this.getLicenseByOrgSiteId(this.props.licenses, license.orgSiteId, LICENSE_TYPE.PAMViewerLicense);
            const explorerLicensesForSite = this.getLicenseByOrgSiteId(this.props.licenses, license.orgSiteId, LICENSE_TYPE.PAMExplorerLicense);
            
            this.setState({ modalState: MODAL_STATE.EDIT, licenseKeyModalHeaderText: 'Edit License Key', editLicense: { ...license, viewerLicenseQuantity: viewerLicensesForSite.length, explorerLicenseQuantity: explorerLicensesForSite.length }, showEditModal: true });
        } else {
            this.setState({ modalState: MODAL_STATE.EDIT, licenseKeyModalHeaderText: 'Edit License Key', editLicense: { ...license }, showEditModal: true });
        }
    }
    showNewModal() {
        //Check disabled to prevent double clicking, which would spawn two dialogs
        if (!this.state.disabled) {
            // Initialize dates to midnight (startOf) for the day they are selecting with the offset in place for later UTC conversion
            this.setState({
                modalState: MODAL_STATE.NEW,
                licenseKeyModalHeaderText: 'Create New License Key',
                editLicense: {
                    validFrom: moment().startOf('day').toDate(),
                    validThrough: moment().startOf('day').add('years', 1).toDate(),
                    licenseTypeId: 1,
                    viewerLicenseQuantity: 0,
                    explorerLicenseQuantity: 0
                },
                showEditModal: true,
                disabled: true
            });
        }
    }
    hideEditModal() {
        this.setState({ licenseKeyModalHeaderText: 'Edit License Key', editLicense: {}, showEditModal: false, disabled: false, licenseModalError: null });
    }

    showDeleteLicenseModal(license, event) {
        this.setState({ editLicense: { ...license }, showDeleteLicenseModal: true });
    }

    hideDeleteLicenseModal() {
        this.setState({ editLicense: {}, showDeleteLicenseModal: false });
    }

    handleDeleteLicense() {
        if (this.state.editLicense.licenseTypeId === LICENSE_TYPE.PAMSiteLicense) {
            licenseService.deletePamLicense(this.state.editLicense.id).then(response => {
                if (response.data.success) {
                    this.props.refetchOrg();
                    this.setState({ editLicense: {}, showDeleteLicenseModal: false });
                }
            });
        } else {
            licenseService.deleteLicense(this.state.editLicense.id).then(response => {
                if (response.data.success) {
                    this.props.refetchOrg();
                    this.setState({ editLicense: {}, showDeleteLicenseModal: false });
                }
            });
        }
    }

    handleSaveLicenseResponse(response) {
        
        if (response.data.success) {
            // TR: 04-06-24
            // refetching the org instead of updating the state directly because otherwise the PAM viewer/explorer license counts cannot updated in the state due to not being returned
            // in the response payload
            this.props.refetchOrg();
            this.hideEditModal();
        } else {
            const errorMessage = response.data.message || 'An error occurred while saving the license.';
            this.setState({ licenseModalError: errorMessage });
        }
    }

    handleSaveLicense = async () => {
        var license = { ...this.state.editLicense };
        license.organizationId = this.props.organizationId;
        license.organizationName = this.props.organizationName;
        license.OrgCode = this.props.orgCode;
        license.State = 100;
        license.validFrom = moment(license.validFrom).startOf('day').toDate();
        license.validFrom = moment.utc(license.validFrom);
        license.validThrough = moment(license.validThrough).startOf('day').toDate();
        license.validThrough = moment.utc(license.validThrough);

        this.setState({ licenseModalError: null });

        if (this.state.editLicense.licenseTypeId === LICENSE_TYPE.PAMSiteLicense) {
            license.userAssignablePamLicenses = [
                { licenseTypeId: LICENSE_TYPE.PAMViewerLicense, quantity: license.viewerLicenseQuantity },
                { licenseTypeId: LICENSE_TYPE.PAMExplorerLicense, quantity: license.explorerLicenseQuantity },
            ];

            try {
                const saveLicenseResponse = await licenseService.savePamLicense(license);
                this.handleSaveLicenseResponse(saveLicenseResponse);
            } catch (error) {
                this.setState({ licenseModalError: 'An unexpected error occurred while saving the license.' });
            }

        } else {
            licenseService.saveLicense(license)
                .then(response => {
                    if (response?.data?.success && license.licenseTypeId === layerJotLicenseType && typeof this.props.modifyState === 'function') {
                        const organization = { ...this.props.organization, hasValidLayerJotLicense: true };
                        this.props.modifyState("organization", organization);
                    }

                    this.handleSaveLicenseResponse(response);
                })
                .catch(() => {
                    this.setState({ licenseModalError: 'An unexpected error occurred while saving the license.' });
                });
        }
    }

    handleUserInput(event) {
        // taken straight from the official React Docs
        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var partialState = this.state.editLicense;
        partialState[name] = value;
        this.setState({ editLicense: partialState });
    }

    handleUserIntInput(event) {
        // taken straight from the official React Docs
        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
        const target = event.target;
        const value = parseInt(target.value);
        const name = target.name;
        var partialState = { ...this.state.editLicense };
        partialState[name] = value;
        this.setState({ editLicense: partialState });
    }

    licensesWithoutPamUserAssignable() {
        return this.props.licenses.filter(l => !USER_ASSIGNABLE_PAM_LICENSE_TYPE_IDS.includes(l.licenseTypeId))
    }

    pamLicenseTypeSelectedAndSiteHasExistingPamLicense() {
        return (
            (this.state.modalState === MODAL_STATE.NEW) && 
            (this.state.editLicense.licenseTypeId === LICENSE_TYPE.PAMSiteLicense) && 
            (this.props.licenses.some(l => l.orgSiteId === this.state.editLicense.orgSiteId && l.licenseTypeId === LICENSE_TYPE.PAMSiteLicense))
        );
    }

    isInvalidPamQuantity(quantity) {
        return isNaN(parseInt(quantity));
    }

    pamLicenseTypeSelectedAndQuantityFieldsAreInvalid() {
        const quantityFields = [ this.state.editLicense.viewerLicenseQuantity, this.state.editLicense.explorerLicenseQuantity ]
        return (
            (this.state.editLicense.licenseTypeId === LICENSE_TYPE.PAMSiteLicense) && 
            (quantityFields.some(q => this.isInvalidPamQuantity(q)))
        );
    }

    pamLicenseTypeSelectedAndNoTenantDatabaseIsCreated() {
        return (
            (this.state.editLicense.licenseTypeId === LICENSE_TYPE.PAMSiteLicense) &&
            (!this.props.canSavePamLicense)
        );
    }

    render() {
        return (
            <div>
                <Modal bsSize="small" show={this.state.showDeleteLicenseModal}>
                    <Modal.Header>
                        <Modal.Title>Confirm Deletion</Modal.Title>

                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete the license key?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.hideDeleteLicenseModal} variant="default" type="button">Cancel</Button>
                        <Button onClick={this.handleDeleteLicense} variant="danger" type="button">Delete</Button>
                    </Modal.Footer>
                </Modal>
                <Modal bsSize="small" show={this.state.showEditModal}>
                    <Modal.Header>
                        <Modal.Title>
                            {this.state.licenseKeyModalHeaderText}
                        </Modal.Title>

                        {this.state.licenseModalError && (
                            <div className="text-danger" style={{ fontSize: '0.9em', marginTop: '5px' }}>
                                {this.state.licenseModalError}
                            </div>
                        )}
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                            <label htmlFor="LicenseTypeId">License Type</label>
                            <select className="form-control" name="licenseTypeId" id="licenseTypeId" value={this.state.editLicense.licenseTypeId} required onChange={this.handleUserIntInput}>
                                <option value='1'>Sms Messaging Api</option>
                                <option value='2'>Email Messaging Api</option>
                                <option value='4'>OR Portal License</option>
                                <option value='5'>LayerJot License</option>
                                <option value='6'>Performance Analytics Module</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="orgSiteId">Site Id</label>
                            <select className="form-control" name="orgSiteId" id="orgSiteId" required value={this.state.editLicense.orgSiteId} onChange={this.handleUserIntInput}>
                                <option>Please pick a site</option>
                                {
                                    this.props.sites.map((item, i) => {
                                        return (
                                            <option key={i} value={item.id}>{item.name + ' (' + item.siteCode + ')'}</option>
                                        );
                                    })
                                }
                            </select>
                            
                            {this.pamLicenseTypeSelectedAndSiteHasExistingPamLicense() ? (
                                <small id="siteCodeHelp" className="form-text text-danger">PAM Site license already exists for this site. Please select a different site, or edit the existing PAM Site license.</small>
                            ) : (
                                <small id="siteCodeHelp" className="form-text text-muted">Please enter the site code.</small>
                            )}
                        </div>
                        <div className="form-group">
                            <label htmlFor="validFrom">Valid From</label>
                            <input type='date' className="form-control" id="validFrom" name="validFrom"
                                value={moment(this.state.editLicense.validFrom).format(dateFormat)}
                                aria-describedby="validFromHelp" onChange={this.handleUserInput} required />
                            <small id="validFromHelp" className="form-text text-muted">Please enter the start date of the license.</small>
                        </div>
                        <div className="form-group">
                            <label htmlFor="validThrough">Valid Through</label>
                            <input type='date' className="form-control" id="validThrough" name="validThrough" value={moment(this.state.editLicense.validThrough).format(dateFormat)} aria-describedby="validThroughHelp" onChange={this.handleUserInput} required />
                            <small id="validThroughHelp" className="form-text text-muted">Please enter the end date of the license or leave blank for an indefinite ending.</small>
                        </div>
                        {this.state.editLicense.licenseTypeId === LICENSE_TYPE.PAMSiteLicense && (
                            <>
                                <div className="form-group">
                                    <label htmlFor="viewerLicenseQuantity">Viewer License Quantity</label>
                                    <input 
                                        className="form-control" 
                                        type="number" 
                                        id="viewerLicenseQuantity" 
                                        name="viewerLicenseQuantity" 
                                        value={this.state.editLicense.viewerLicenseQuantity}
                                        onChange={this.handleUserIntInput} 
                                        min={0}
                                    />
                                    {this.isInvalidPamQuantity(this.state.editLicense.viewerLicenseQuantity) && <small id="viewerLicenseQuantityHelp" className="form-text text-danger">Please enter a valid number.</small>}
                                </div>

                                <div className="form-group">
                                    <label htmlFor="explorerLicenseQuantity">Explorer License Quantity</label>
                                    <input
                                        className="form-control" 
                                        type="number" 
                                        id="explorerLicenseQuantity" 
                                        name="explorerLicenseQuantity" 
                                        value={this.state.editLicense.explorerLicenseQuantity} 
                                        onChange={this.handleUserIntInput} 
                                        min={0}
                                    />
                                    {this.isInvalidPamQuantity(this.state.editLicense.explorerLicenseQuantity) && <small id="explorerLicenseQuantityHelp" className="form-text text-danger">Please enter a valid number.</small>}
                                </div>

                                {!this.props.canSavePamLicense && <div><small id="siteCodeHelp" className="form-text text-danger">You need to have a tenant db to create a PAM License</small></div>}
                                
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.hideEditModal} variant="warning" type="button">Cancel</Button>
                        <Button onClick={this.handleSaveLicense} variant="primary" disabled={!this.state.editLicense.validFrom || this.pamLicenseTypeSelectedAndSiteHasExistingPamLicense() || this.pamLicenseTypeSelectedAndQuantityFieldsAreInvalid() || this.pamLicenseTypeSelectedAndNoTenantDatabaseIsCreated()} type="button">Save</Button>
                    </Modal.Footer>
                </Modal>
                <Row>
                    <Col md={12}>
                        <Table striped condensed hover responsive>
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Site</th>
                                    <th>Valid From</th>
                                    <th>Valid Through</th>
                                    <th />
                                    <th>
                                        <span className="fa-layers fa-fw text-success float-right show-hand"
                                            onClick={this.showNewModal} disabled={this.state.disabled}>
                                            <FontAwesomeIcon icon={faKey} transform={{ rotate: -45 }} />
                                            <FontAwesomeIcon icon={faPlus} transform="shrink-8 right-10" />
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.licensesWithoutPamUserAssignable().map((item, i) => {
                                        return (
                                            <tr key={i}>
                                                <td>{item.licenseType}</td>
                                                <td>{item.siteName}</td>
                                                <td>{moment(item.validFrom).format(dateDisplayFormat)}</td>
                                                <td>{!item.validThrough ? "Forever" : moment(item.validThrough).format(dateDisplayFormat)}</td>
                                                <td className="table-fit"><FontAwesomeIcon icon={faPen} className="gi-1-5x text-primary show-hand" onClick={(e) => this.showEditModal(item, e)} /></td>
                                                <td className="table-fit"><FontAwesomeIcon icon={faTimesCircle} className="gi-1-5x text-danger show-hand" onClick={(e) => this.showDeleteLicenseModal(item, e)} /></td>
                                            </tr>
                                        );
                                    }
                                    )
                                }
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default LicenseKeys;
